module.exports = __webpack_public_path__ + "static/media/clark-street-mercantile.e389cfad.jpg";